





































import { Vue, Component, Prop } from 'vue-property-decorator'
import BagsECrediarioNoCaixa from './BagsECrediarioNoCaixa.vue'
import EtiquetaDeAniversario from './EtiquetaDeAniversario.vue'
import MixETopPecasNoCaixa from './MixETopPecasNoCaixa.vue'
import PerfilEPosicaoDoCliente from './PerfilEPosicaoDoCliente.vue'
import type { Cliente } from '@/models'

const PAINEL_DE_PERFIL = 0

@Component({
	components: {
		BagsECrediarioNoCaixa,
		EtiquetaDeAniversario,
		MixETopPecasNoCaixa,
		PerfilEPosicaoDoCliente,
	},
})
export default class PainelDoCliente extends Vue {
	@Prop({ type: Object, required: true }) cliente!: Cliente
	@Prop({ type: String, required: true }) lojaId!: string

	paineisAbertos: number[] = [PAINEL_DE_PERFIL]

	get nomeDoCliente() {
		return this.cliente.razaoSocialOuNome
	}

	get dataDeNascimento() {
		return this.cliente.dataNascimento
	}
}
